import clsx from 'clsx';
import PropTypes from 'prop-types';
import * as React from 'react';
import app from '@frontastic/catwalk/src/js/app/app';

import styles from './Notification.module.scss';
import Button from '../button';

const types = {
  error: 'error',
  error_text: 'error_text',
  success: 'success',
};

export const formatErrorMessage = (text) => {
  if (typeof text === 'string' && text?.includes('The cart is frozen.')) {
    return (
      <div className={styles.errorWithLink}>
        Error Code 30: An unexpected error has occurred on your session. Please navigate back to your cart, review your
        items and try placing your order again.
        <Button
          shape="square"
          variant="primary"
          as="text"
          onClick={() => app.getRouter().push('Frontastic.Frontend.Master.Checkout.cart')}
        >
          Click here to return to your cart
        </Button>
      </div>
    );
  }
  return text;
};

const Notification = ({ message = Notification.message, type = Notification.type, className }) => {
  let typeClass = types.success;
  if (Object.keys(types).includes(type)) {
    typeClass = types[type];
  }

  const classes = clsx(styles.notification, styles[typeClass], className);

  return <div className={`${classes}`}>{formatErrorMessage(message)}</div>;
};

Notification.propTypes = {
  type: PropTypes.oneOf(Object.keys(types)),
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
};

export default Notification;
